import React from "react";
import "../../../src/App.css";
import "./Footer.css";

function Footer() {
  return <div className="footer">CopyRights @techhabiles.com</div>;
}

export default Footer;
